<template>
  <div>
    <carousel
      :autoplay="true"
      :responsive="{0:{items:1,nav:false},480:{items:2,nav:false}, 768:{items:3,nav:false}}"
    >
      <v-card
        href="#"
        v-ripple="{ 'class': 'rippleBlog'}"
        tile
        class="text-center headingcards"
        img="https://sitkatheme.com/travel/wp-content/uploads/sites/7/2019/10/travl6-1920x1374.jpg"
      >
        <div class="filtro">
          <v-card-text class="aling-self-center titular">
            <h4 class="categoria">Categoría</h4>
            <h2 class="titulo">Titulo de la entrada</h2>
          </v-card-text>
        </div>
      </v-card>
      <v-card
        href="#"
        v-ripple="{ 'class': 'rippleBlog'}"
        tile
        class="text-center headingcards"
        img="https://www.energeticthemes.com/themes/sada/wp-content/uploads/sites/84/2018/11/s2.jpg"
      >
        <div class="filtro">
          <v-card-text class="aling-self-center titular">
            <h4 class="categoria">Categoría</h4>
            <h2 class="titulo">Titulo de la entrada</h2>
          </v-card-text>
        </div>
      </v-card>
      <v-card
        href="#"
        v-ripple="{ 'class': 'rippleBlog'}"
        tile
        class="text-center headingcards"
        img="https://sitkatheme.com/travel/wp-content/uploads/sites/7/2019/10/travel4-1920x1280.jpg"
      >
        <div class="filtro">
          <v-card-text class="aling-self-center titular">
            <h4 class="categoria">Categorías</h4>
            <h2 class="titulo">Titulo de la entrada</h2>
          </v-card-text>
        </div>
      </v-card>
    </carousel>
    <EntradasHome />
  </div>
</template>

<script>
import EntradasHome from "../components/EntradasHome";
import carousel from "vue-owl-carousel";

export default {
  name: "Home",

  components: {
    EntradasHome,
    carousel
  },

  data: () => ({
    //
  })
};
</script>
